import React, { FC } from 'react';
import { IAccordionContainer } from '../../interfaces/umbracoNodes/contentSlices';
import Accordion from './accordion';
import { ContainerRoot } from './accordionContainer.style';

interface Props {
	content: IAccordionContainer;
}
export const AccordionContainer: FC<Props> = ({ content }) => {
	const { IsSideBySide, Accordions } = content.Values;

	return (
		<ContainerRoot isSideBySide={IsSideBySide}>
			{Accordions.map(item => (
				<Accordion key={item.Values.Title} content={item}></Accordion>
			))}
		</ContainerRoot>
	);
};
